import React from 'react';
import {
  Modal, Button, Row, Col, Radio, Steps, Spin,
} from 'antd';
import uniqueId from 'lodash/uniqueId';
import './style/instruction.less';

const Step = Steps.Step;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
// const server = window.server || "";
const server = 'https://e-cloudstore.com';
const e8Arr = [{text: "进入门户首页，右上角进入：【...】->【授权信息】，复制要填写的信息：【授权用户】、【标识码】",
	src: "/ui/images/ecology/e812.png"},
	{text: "填入信息：【授权用户】、【标识码】，注意如果需要永久授权，必须选择【客户】，如果是多个应用集群，则填写标识码用英文逗号隔开，这里注意选择客户自动带出的授权用户有可能和您本地的授权用户不一致，这时候需要修改授权用户",
	src: "/ui/images/ecology/x.png"},
	{text: "到【应用】->【已购买】中点击【获取】下载，可以批量操作，注意每次获取都将得到最新版本，新版本获取不需要重复提交申请",
	src: "/ui/images/ecology/y.png"},
	{text: "下载后将文件覆盖ECOLOGY目录，进入【后台】->【初始配置】->【开始自动检测】，检测通过即可，如果不通过请联系我们",
	src: "/ui/images/ecology/e83.png"},
	{text: "进入【后台】->【应用】，打开您安装好的应用开始使用",
	src: "/ui/images/ecology/e84.png"},
	{text: "到【应用】->【详情】页面查看具体应用的配置/使用文档，如果还未解决您的问题，请在【评论】里留言或者联系【参与者】",
  src: "/ui/images/ecology/z.png"},
  {text: "部分应用支持配置到云桥。请到云桥的门户管理（图一）添加菜单对应配置位置,如图二所选,配置链接地址请到ecology后台云商店授权信息处获取(如图三）",
  src: "/ui/images/ecology/e881.png,/ui/images/ecology/e882.png,/ui/images/ecology/e883.png", 
}
];
const e7Arr = [{text: "进入：【设置】->【设置中心】->【系统信息】->【授权信息】，复制需要填写的信息",
	src: "/ui/images/ecology/e712.png"},
	{text: "填入信息：【授权用户】、【标识码】，注意如果需要永久授权，必须选择【客户】，如果是多个应用集群，则填写标识码用英文逗号隔开，这里注意选择客户自动带出的授权用户有可能和您本地的授权用户不一致，这时候需要修改授权用户",
	src: "/ui/images/ecology/x.png"},
	{text: "到【应用】->【已购买】中点击【获取】下载，可以批量操作，注意每次获取都将得到最新版本，新版本获取不需要重复提交申请",
	src: "/ui/images/ecology/y.png"},
	{text: "下载后将文件覆盖ECOLOGY目录，进入【设置】->【云商店】->【初始配置】->【开始自动检测】，检测通过即可，如果不通过请联系我们",
	src: "/ui/images/ecology/e73.png"},
	{text: "进入【设置】->【云商店】->【应用】，打开您安装好的应用开始使用",
	src: "/ui/images/ecology/e74.png"},
	{text: "到【应用】->【详情】页面查看具体应用的配置/使用文档，如果还未解决您的问题，请在【评论】里留言或者联系【参与者】",
	src: "/ui/images/ecology/z.png"}
];
class Instruction extends React.Component {
  static defaultProps = {
    prefixCls: 'instruction',
  }
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      current: 0,
      type: 'EC8',
      loadedSrc: [e8Arr[0].src],
    }
  }
  onCancel = () => {
    this.setState({ visible: false }, () => this.setState({ type: 'EC8', current: 0, loadedSrc: [e8Arr[0].src] }));
  }
  setImg = (i, nextSrc, step, loadedArr) => {
    i.src = server + nextSrc;
    this.setState({ current: step });
    i.onload = () => {
      loadedArr.push(nextSrc);
      this.setState({ loadedSrc: loadedArr });
    }
  }
  goStep(s){
    const { loadedSrc, type } = this.state;
    const maxStep = type === 'EC8' ? 6 : 5;
    let step = s > maxStep ? 0 : (s < 0 ? maxStep : s);
		const nextSrc = type === "EC8" ? e8Arr[step].src : e7Arr[step].src;
		let loadedArr = [].concat();
		if(loadedArr.join().indexOf(nextSrc) < 0){
			let i = new Image();
      if (type === 'EC8' && step === maxStep) {
        nextSrc.split(',').forEach(v => {
          this.setImg(i, v, step, loadedArr);
        });
      } else {
        this.setImg(i, nextSrc, step, loadedArr);
      }
		}else{
			this.setState({ current: step });
		}
  }
  
  render() {
    const { prefixCls } = this.props;
    const { visible, current, type, loadedSrc } = this.state;
    const steps = ["获取授权信息", "填写授权信息", "下载应用", "部署应用", "进入应用", "使用文档"];
    if (type === 'EC8') steps.push("云桥应用");
    const text = type === "EC8" ? e8Arr[current].text : e7Arr[current].text;
    const src = type === "EC8" ? e8Arr[current].src : e7Arr[current].src;
    const maxStep = type === 'EC8' ? 6 : 5;
    let loadImg = loadedSrc.join().indexOf(src) < 0;
    if (type === 'EC8' && current === maxStep) {
      loadImg = false;
      src.split(',').forEach(v => {
        loadImg = JSON.stringify(loadedSrc).indexOf(v) < 0;
      });
    }
    return (
      <div className={prefixCls}>
        <a alt="" onClick={() => this.setState({ visible: true })}>如何申请 / 部署 / 使用？</a>
        <Modal
          title="如何申请 / 部署 / 使用？"
          className={`${prefixCls}-Modal`}
          visible={visible}
          onCancel={this.onCancel}
          maskClosable={false}
          width={1000}
          bodyStyle={{ height: 650 }}
          footer={[
            <Button key="pre" type="primary" onClick={() => this.goStep(current - 1)}>上一步</Button>,
            <Button key="next" type="primary" onClick={() => this.goStep(current + 1)}>下一步</Button>,
            <Button key="cusCancel" onClick={this.onCancel}>返回</Button>,
          ]}
        >
          <Row>
            <Col span={4}>
              <RadioGroup onChange={e=>this.setState({ type: e.target.value, current: 0, loadedSrc: e.target.value === 'EC8' ? [e8Arr[0].src] : [e7Arr[0].src], })} value={type} style={{marginBottom:15}}>
                <RadioButton value="EC8">EC8</RadioButton>
                <RadioButton value="EC7">EC7</RadioButton>
              </RadioGroup>
              <Steps current={current} direction="vertical" size="small">
              {
                steps.map(v => (<Step key={`stepKey_${uniqueId()}`} title={v}/>))
              }
						</Steps>
            </Col>
            <Col span={20}>
              <p style={{marginBottom:5}}>{text}</p>
              <div style={{ textAlign:"center" }}>
                <Spin spinning={loadImg}>
                  {
                    type === 'EC8' && current === maxStep ? src.split(',').map((v, index) => (
                      <div key={`stepImg_${uniqueId()}`} style={{display: 'inline-block', textAlign: 'center', width: index !== 2 ? '50%' : '100%'}}>
                        <img src={server + v} style={{maxHeight: 255}} alt="" />
                        <div>图({index === 0 ? '一' : index === 1 ? '二' : '三'})</div>
                      </div>
                    )) : (
                      <img src={server + src} width="100%" alt="" style={{maxHeight:550}} />
                    )
                  }
                </Spin>
              </div>
            </Col>
          </Row>
        </Modal>
      </div>
    )
  }
}

export default Instruction;


// WEBPACK FOOTER //
// ./src/components/util/appApply/Instruction.js